import {Address} from "../../../domain/geocode-types";
import {Driver, Job, ManifestStopJob, ManifestFilter} from "../../../generated/graphql";
import {ManifestSortOptions} from "../../../providers/AssignmentViewReducer";
import {TManifestEnhanced} from "../../common/types";

import {ManifestFilterState} from "../list/components/manifest-filter/ManifestFilterState";
import {DetailViews} from "./ManifestDetailsContainer";

type ManifestDetailsAssignmentState = {
  selectedManifest?: TManifestEnhanced;
  selectedManifestDriver?: Driver;
  manifestDriverHomeAddress?: Address;
  selectedJobs?: (Job | ManifestStopJob)[];
  detailsViewType: DetailViews;
  manifestId?: number;
  assignDriverManifestFilter?: ManifestFilter;
  assignDriverManifestFilterState?: ManifestFilterState;
  assignDriverManifestSort?: ManifestSortOptions;
  assignDriverManifestQuery?: string;
};

type ManifestDetailsAssignmentActions =
  | {type: "SET_SELECTED_MANIFEST"; payload: TManifestEnhanced | undefined}
  | {type: "SET_MANIFESET_ID"; payload: number}
  | {type: "SET_SELECTED_JOB"; payload: Job | ManifestStopJob | undefined}
  | {type: "SET_SELECTED_MANIFEST_DRIVER"; payload: Driver | undefined}
  | {type: "SET_MANIFEST_DRIVER_HOME_ADDRESS"; payload: Address | undefined}
  | {type: "SET_DETAILS_VIEW_TYPE"; payload: DetailViews}
  | {type: "SET_ASSIGNDRIVER_MANIFEST_FILTER"; payload: ManifestFilter}
  | {type: "SET_ASSIGNDRIVER_MANIFEST_FILTER_STATE"; payload: ManifestFilterState}
  | {type: "SET_ASSIGNDRIVER_MANIFEST_SORT"; payload: ManifestSortOptions}
  | {type: "SET_ASSIGNDRIVER_MANIFEST_QUERY"; payload: string}
  | {type: "CLEAR_ALL_STATES"};

const manifestDetailsReducer = (
  state: ManifestDetailsAssignmentState,
  action: ManifestDetailsAssignmentActions
): ManifestDetailsAssignmentState => {
  switch (action.type) {
    case "SET_SELECTED_MANIFEST":
      return {...state, selectedManifest: action.payload};
    case "SET_MANIFESET_ID":
      return {...state, manifestId: action.payload};
    case "SET_SELECTED_MANIFEST_DRIVER":
      return {...state, selectedManifestDriver: action.payload};
    case "SET_MANIFEST_DRIVER_HOME_ADDRESS":
      return {...state, manifestDriverHomeAddress: action.payload};
    case "SET_DETAILS_VIEW_TYPE":
      return {...state, detailsViewType: action.payload};
    case "SET_ASSIGNDRIVER_MANIFEST_FILTER":
      return {...state, assignDriverManifestFilter: action.payload};
    case "SET_ASSIGNDRIVER_MANIFEST_FILTER_STATE":
      return {...state, assignDriverManifestFilterState: action.payload};
    case "SET_ASSIGNDRIVER_MANIFEST_SORT":
      return {...state, assignDriverManifestSort: action.payload};
    case "SET_ASSIGNDRIVER_MANIFEST_QUERY":
      return {...state, assignDriverManifestQuery: action.payload};
    case "CLEAR_ALL_STATES":
      return {
        ...state,
        selectedManifest: undefined,
        selectedJobs: [],
        selectedManifestDriver: undefined,
        manifestId: undefined,
        manifestDriverHomeAddress: undefined,
        detailsViewType: "NONE"
      };
    default:
      return state;
  }
};

export default manifestDetailsReducer;
export type {ManifestDetailsAssignmentState, ManifestDetailsAssignmentActions};
